import {
  Box,
  Container,
  Text,
  Image,
  Link,
  Button
} from "@chakra-ui/react";
import {
  ContentNotFound,
  Hero,
  Layout,
  ShowMore
} from "@common";
import { ISSRPageData } from "@interfaces";
import { PageService } from "@services";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { Markup } from "interweave";
import { MotionImage } from "@ui";
import { createNavLink } from "@utils";


const CardHorizontal = ({ locale }) => {
  const { t } = useTranslation();

  return (
    <Box
      as="section"
      position="relative"
      pb={20}
    >
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        zIndex="-1"
      >
        <MotionImage
          imgUrl="/img/explore-art/kid/banner/shape-2.png"
          imgAlt="Shape"
          containerProps={{
            style: {
              position: "absolute",
              top: "400px",
              left: "63px"
            }
          }}
          motionProps={{
            animate: { y: 70 },
            transition: {
              repeat: Infinity,
              repeatType: "reverse",
              duration: 2
            }
          }}
          imageProps={{
            width: "68px"
          }}
        />

        <MotionImage
          imgUrl="/img/exhibition-and-event-detail/for-kids/kids-element-2.png"
          imgAlt="Shape"
          motionProps={{
            animate: { y: 70 },
            transition: {
              repeat: Infinity,
              repeatType: "reverse",
              duration: 4
            }
          }}
          containerProps={{
            position: "absolute",
            top: "90px",
            left: "30px"
          }}
        />


        <MotionImage
          imgUrl="/img/explore-art/kid/banner/shape-5.png"
          imgAlt="Shape"
          containerProps={{
            style: {
              position: "absolute",
              top: "0px",
              right: "7%"
            }
          }}
          imageProps={{
            width: "60px"
          }}
          motionProps={{
            animate: { y: 70 },
            transition: {
              repeat: Infinity,
              repeatType: "reverse",
              duration: 3
            }
          }}
        />
      </Box>
      <Container>
        <Box
          display="flex"
          flexDirection={{ base: "column", lg: "row" }}
          gap={{ base: 6, lg: 10 }}
          justifyContent="center"
        >
          <Box
            position="relative"
            flex="1"
            p={{ base: "padding.primary", lg: "padding.primary" }}
            boxShadow="xl"
            rounded="3xl"
            bgColor="white.primary"
          >
            <Image
              src="/img/exhibition-and-event/cocuk-atolye.jpg"
              fallbackSrc="/img/placeholders/no-image-available-icon.jpeg"
              width="full"
              rounded="3xl"
              boxShadow="xl"
              height="250px"
              objectFit="cover"
              alt="Çocuk Atölyeleri"
            />

            <Text
              fontFamily={"mikado"}
              as="h2"
              fontWeight="bold"
              fontSize={{ base: "2xl", lg: "3xl" }}
              lineHeight="none"
              textAlign="center"
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              mt="padding.primary"
            >
              <Link href={createNavLink("learningFilter", locale)} isExternal>
                <Text
                  fontFamily={"mikado"}
                  as="span"
                  fontWeight="extrabold"
                  color="pink.primary2"
                  position="relative"
                  _before={{
                    content: `""`,
                    position: "absolute",
                    top: "8px",
                    right: "-190%",
                    width: "27px",
                    height: "48px",
                    backgroundImage:
                      "url(\"/img/explore-art/kid/custom-cursor-for-kids.png\")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain"
                  }}
                >
                  {t("explore-art:kid.childrensWorkshops.childrens")}
                </Text>
                <Text fontWeight="extrabold"
                      fontFamily={"mikado"} as="span" color="red.primary4">
                  &nbsp;{t("explore-art:kid.childrensWorkshops.workshops")}

                </Text>
              </Link>
            </Text>
          </Box>

          <Box
            position="relative"
            flex="1"
            p={{ base: "padding.primary", lg: "padding.primary" }}
            boxShadow="xl"
            rounded="3xl"
            bgColor="white.primary"
          >
            <Image
              src="/img/exhibition-and-event/rehberli-turlar.jpg"
              fallbackSrc="/img/placeholders/no-image-available-icon.jpeg"
              width="full"
              rounded="3xl"
              boxShadow="xl"
              height="250px"
              objectFit="cover"
              alt="Çocuk Atölyeleri"
            />

            <Text
              fontFamily={"mikado"}
              as="h2"
              fontWeight="bold"
              fontSize={{ base: "2xl", lg: "2xl" }}
              lineHeight="none"
              textAlign="center"
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              mt="padding.primary"
            >
              <Link href={createNavLink("museumToursForStudents", locale)} isExternal>
                <Text
                  fontFamily={"mikado"}
                  as="span"
                  fontWeight="extrabold"
                  color="yellow.primary2"
                  position="relative"
                  _before={{
                    content: `""`,
                    position: "absolute",
                    top: "8px",
                    right: "-110%",
                    width: "27px",
                    height: "48px",
                    backgroundImage:
                      "url(\"/img/explore-art/kid/custom-cursor-for-kids.png\")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain"
                  }}
                >
                  {t("explore-art:kid.guidedTours.guided")}
                </Text>
                <Text fontWeight="extrabold"
                      fontFamily={"mikado"} as="span" color="blue.primary2">
                  &nbsp;{t("explore-art:kid.guidedTours.tours")}
                </Text>
              </Link>
            </Text>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};


const LearningPage = ({
                        pageData,
                        global: { navigation }
                      }: ISSRPageData) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { asPath, locale } = router;

  if (pageData.error) {
    return (
      <Layout
        title={t("common:eventCard.learning")}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    );
  }

  return (
    <Layout
      title={t("common:eventCard.learning")}
      navigation={navigation}
      path={asPath}

    >
      <Hero
        bgImageUrl={"/img/exhibition-and-event/ogrenme-banner.jpg"}
        title={t("common:eventCard.learning")}
      />

      <Container maxW="container.xl" mt={10} mb={10}>
        <Text
          as="h2"
          color="red.primary"
          fontSize={{ base: "2xl", lg: "3xl" }}
          mb={{ base: "padding.primary", lg: "padding.primary" }}
        >
          {t("explore-art:learningPageKids.title")}
        </Text>
        <ShowMore isOnlyMobileWork={false} startingHeight={110}>
          <Box fontWeight="light" fontSize="sm" color="black.primary3">
            <Markup content={t("explore-art:learningPageKids.description")} />
          </Box>
        </ShowMore>
        <Text
          as="h2"
          color="red.primary"
          fontSize={{ base: "2xl", lg: "3xl" }}
          mb={{ base: "padding.primary", lg: "padding.primary" }}
        >
          {t("explore-art:learningPageTitleKid")}
        </Text>

      </Container>
      <CardHorizontal
        locale={locale}
      />

      <Container>
        <Text
          as="h2"
          color="red.primary"
          fontSize={{ base: "2xl", lg: "3xl" }}
        >
          {t("explore-art:learningPageTitleAdult")}
        </Text>
        <Text
          as="p"
          color="black.primary"
          mb={{ base: "padding.primary", lg: "padding.primary" }}

        >
          {t("explore-art:learningPageDescAdult")}

        </Text>

        <Box
          display="grid"
          gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }}
          pb={10}
          gap={8}
        >
          {[
            {
              title: t("explore-art:AdultWorkshop.title"),
              description:
                t("explore-art:AdultWorkshop.description"),
              imageUrl:
                "/img/exhibition-and-event/yetiskin-atolye.jpg",
              linkUrl: createNavLink("learningAdultWorkshop", locale),
            },
            {
              title: t("explore-art:AdultSeminar.title"),
              description: t("explore-art:AdultSeminar.description"),
              imageUrl:
                "/img/exhibition-and-event/yetiskin-semineri.jpg",
              linkUrl: createNavLink("learningAdultSeminar", locale),

            },
            {
              title: t("explore-art:Conferences.title"),
              description: t("explore-art:Conferences.description"),
              imageUrl:
                "/img/exhibition-and-event/konferans.jpg",
              linkUrl: createNavLink("eventConference", locale),
            },
            {
              title: t("explore-art:GuidedTours.title"),
              description: t("explore-art:GuidedTours.description"),
              imageUrl:
                "/img/exhibition-and-event/rehberli-turlar.jpg",
              linkUrl: createNavLink("museumToursForAdult", locale),
            }
          ].map((program, index) => (
            <Box
              key={index}
              position="relative"
              boxShadow="lg"
              rounded="xl"
              overflow="hidden"
              bgColor="white.primary"

            >
              <Image
                src={program.imageUrl}
                fallbackSrc="/img/placeholders/no-image-available-icon.jpeg"
                width="full"
                height="250px"
                objectFit="cover"
                alt={program.title}
              />
              <Box p={6}>
                <Text
                  as="h3"
                  fontSize={{ base: "lg", lg: "xl" }}
                  fontWeight="bold"
                  mb={4}
                  color="blue.primary"
                >
                  {program.title}
                </Text>
                <Text fontSize="sm" color="black.primary3">
                  {program.description}
                </Text>
                <Button
                  as={Link}
                  href={program.linkUrl}
                  position="relative"
                  variant="primary"
                  mt={5}

                >
                  {t("explore-art:discoverArt.buttonExamineLabel")}
                </Button>

              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Layout>
  );
};

export default LearningPage;

// Sayfa Verilerini Getir
export async function getStaticProps({ locale }) {
  const pageData = {
    data: null,
    error: null
  };

  try {
    const collection = await PageService.getHomePage(locale);
    pageData.data = collection;
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message };
    }
  }

  return {
    props: { pageData },
    revalidate: 120
  };
}
